/**
 * Ensures the given value is always converted into an Error object.
 * - Error => returned as-is
 * - null / undefined => descriptive synthetic error
 * - other => coerced into message with fallback prefix, name=AppError
 */
export function ensureError(
  error: unknown,
  fallbackMessage = 'Unexpected error'
): Error {
  if (error instanceof Error) return error;

  let message: string;
  if (error === undefined) message = 'Undefined value was thrown';
  else if (error === null) message = 'Null value was thrown';
  else message = `${fallbackMessage}: ${String(error)}`;

  const err = new Error(message);
  err.name = 'AppError';
  return err;
}
